import { Fragment, PropsWithChildren } from 'react';
import { FlexBox } from '@ardoq/layout';

type DoqAndTextPositionerProps = { shouldStack: boolean };

export const DoqAndTextPositioner = ({
  shouldStack,
  children,
}: PropsWithChildren<DoqAndTextPositionerProps>) => {
  return shouldStack ? (
    <Fragment>{children}</Fragment>
  ) : (
    <FlexBox gap="medium">{children}</FlexBox>
  );
};
